"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterNumberCell = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const select_1 = require("../../select/select");
const text_field_1 = require("../../text-field/text-field");
const field_filter_api_1 = require("../field-filter-api");
const field_filter_hook_1 = require("../field-filter-hook");
const field_filter_styles_1 = require("../field-filter-styles");
function FilterNumberCell({ disabled, value, onChange, state, onChangeState, }) {
    const classes = (0, field_filter_styles_1.useFilterStyles)();
    const operations = (0, field_filter_api_1.useCompareOperations)();
    const { handleChangeOperation } = (0, field_filter_hook_1.useFilterOperation)(state, onChangeState);
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)(classes.root, { [classes.disabled]: disabled }) },
        react_1.default.createElement("div", { className: classes.selectWrapper },
            react_1.default.createElement(select_1.Select, { source: operations, value: state.operation, onChange: handleChangeOperation, valueIsId: true, clearable: false, disabled: disabled })),
        react_1.default.createElement("div", { className: classes.textWrapper },
            react_1.default.createElement(text_field_1.TextField, { value: value, onChange: onChange, disabled: disabled, type: "number" }))));
}
exports.FilterNumberCell = FilterNumberCell;
//# sourceMappingURL=filter-number-cell.js.map